import script from "./HeaderLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderLayout.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderLayout.vue?vue&type=style&index=0&id=b907344c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b907344c"]])

export default __exports__